module.exports = __webpack_public_path__ + "img/david_potts_x2.91cb49c8.jpg";